import type { _AssetMap } from '../types/empty-state-types.js';

export const EMTPY_STATE_ASSET_MAP: _AssetMap = {
  chart: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/chart-create-new-dark-052d72ca30.svg',
      light: 'https://dt-cdn.net/images/chart-create-new-light-c385b5fdff.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/chart-no-permission-dark-6ffe51ec61.svg',
      light:
        'https://dt-cdn.net/images/chart-no-permission-light-7272fa74c3.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/chart-no-result-dark-78abbbd85b.svg',
      light: 'https://dt-cdn.net/images/chart-no-result-light-7f9c5ef30b.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/chart-something-missing-dark-3853b17f8f.svg',
      light:
        'https://dt-cdn.net/images/chart-something-missing-light-6dc0e87402.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/chart-something-wrong-dark-956491d9cd.svg',
      light:
        'https://dt-cdn.net/images/chart-something-wrong-light-b624204eb3.svg',
    },
  },
  table: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/table-create-new-dark-ba0624b149.svg',
      light: 'https://dt-cdn.net/images/table-create-new-light-db7f37f641.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/table-no-permission-dark-e5383630bd.svg',
      light:
        'https://dt-cdn.net/images/table-no-permission-light-49a61e414f.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/table-no-result-dark-68a45d7852.svg',
      light: 'https://dt-cdn.net/images/table-no-result-light-0aea1a1233.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/table-something-missing-dark-2b7a944985.svg',
      light:
        'https://dt-cdn.net/images/table-something-missing-light-640af56f7d.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/table-something-wrong-dark-e789ecd0e0.svg',
      light:
        'https://dt-cdn.net/images/table-something-wrong-light-5d933b4dac.svg',
    },
  },
  query: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/query-create-new-dark-82ba18a9bf.svg',
      light: 'https://dt-cdn.net/images/query-create-new-light-e795090014.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/query-no-permission-dark-4598cbacd3.svg',
      light:
        'https://dt-cdn.net/images/query-no-permission-light-5996cb4f2b.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/query-no-result-dark-40a6b9b832.svg',
      light: 'https://dt-cdn.net/images/query-no-result-light-472b0a5ccb.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/query-something-missing-dark-76b18c3e92.svg',
      light:
        'https://dt-cdn.net/images/query-something-missing-light-9ddea8be81.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/query-something-wrong-dark-e930a45cdf.svg',
      light:
        'https://dt-cdn.net/images/query-something-wrong-light-3b51b5fc41.svg',
    },
  },
  generic: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/generic-create-new-dark-ee2258fd2f.svg',
      light:
        'https://dt-cdn.net/images/generic-create-new-light-885921ab40.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/generic-no-permission-dark-817a91781b.svg',
      light:
        'https://dt-cdn.net/images/generic-no-permission-light-bdf50c89b0.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/generic-no-result-dark-aa0f7a1435.svg',
      light: 'https://dt-cdn.net/images/generic-no-result-light-dc891bc14d.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/generic-something-missing-dark-1d769c3754.svg',
      light:
        'https://dt-cdn.net/images/generic-something-missing-light-d74815c548.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/generic-something-wrong-dark-cd26ed6f77.svg',
      light:
        'https://dt-cdn.net/images/generic-something-wrong-light-1c3eb8823e.svg',
    },
  },
  document: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/document-create-new-dark-3ed278ab63.svg',
      light:
        'https://dt-cdn.net/images/document-create-new-light-5d0ca29520.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/document-no-permission-dark-a5132e3ad2.svg',
      light:
        'https://dt-cdn.net/images/document-no-permission-light-7dfb08b045.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/document-no-result-dark-0e253a7131.svg',
      light:
        'https://dt-cdn.net/images/document-no-result-light-f846cec211.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/document-something-missing-dark-4da05df220.svg',
      light:
        'https://dt-cdn.net/images/document-something-missing-light-759cc146d7.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/document-something-wrong-dark-9af73b5988.svg',
      light:
        'https://dt-cdn.net/images/document-something-wrong-light-d11398e80a.svg',
    },
  },
};

export const VISUAL_REFRESH_EMPTY_STATE_ASSET_MAP: _AssetMap = {
  chart: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/chart-create-new-dark-0745a5c38c.svg',
      light: 'https://dt-cdn.net/images/chart-create-new-light-bfebf1d919.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/chart-no-permission-dark-b73ce620a2.svg',
      light:
        'https://dt-cdn.net/images/chart-no-permission-light-dd352b4154.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/chart-no-result-dark-fe4ad056c5.svg',
      light: 'https://dt-cdn.net/images/chart-no-result-light-b6e2507938.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/chart-something-missing-dark-56cfd890db.svg',
      light:
        'https://dt-cdn.net/images/chart-something-missing-light-d588de54ab.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/chart-something-wrong-dark-bfa1a4b1aa.svg',
      light:
        'https://dt-cdn.net/images/chart-something-wrong-light-747b7784c9.svg',
    },
  },
  table: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/table-create-new-dark-d9dde2733f.svg',
      light: 'https://dt-cdn.net/images/table-create-new-light-87fed7ec41.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/table-no-permission-dark-f961ff6a96.svg',
      light:
        'https://dt-cdn.net/images/table-no-permission-light-1614fdb4e8.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/table-no-result-dark-f3ff98c8d9.svg',
      light: 'https://dt-cdn.net/images/table-no-result-light-a2f9fa16c9.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/table-something-missing-dark-010a8d7e97.svg',
      light:
        'https://dt-cdn.net/images/table-something-missing-light-b0d4a2e942.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/table-something-wrong-dark-267bfa0285.svg',
      light:
        'https://dt-cdn.net/images/table-something-wrong-light-9d153b8e61.svg',
    },
  },
  query: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/query-create-new-dark-4444bb2528.svg',
      light: 'https://dt-cdn.net/images/query-create-new-light-3915008c93.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/query-no-permission-dark-640141bbd0.svg',
      light:
        'https://dt-cdn.net/images/query-no-permission-light-0ea32b03e2.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/query-no-result-dark-35f5345e69.svg',
      light: 'https://dt-cdn.net/images/query-no-result-light-1c2a38e0df.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/query-something-missing-dark-a597326eca.svg',
      light:
        'https://dt-cdn.net/images/query-something-missing-light-1b21f004c7.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/query-something-wrong-dark-9bcd9551de.svg',
      light:
        'https://dt-cdn.net/images/query-something-wrong-light-b9f597dfc7.svg',
    },
  },
  generic: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/generic-create-new-dark-879b550b68.svg',
      light:
        'https://dt-cdn.net/images/generic-create-new-light-e32186065d.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/generic-no-permission-dark-a337852730.svg',
      light:
        'https://dt-cdn.net/images/generic-no-permission-light-9d1cb7cae2.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/generic-no-result-dark-d539077d97.svg',
      light: 'https://dt-cdn.net/images/generic-no-result-light-b0f72d8592.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/generic-something-missing-dark-81e97a029e.svg',
      light:
        'https://dt-cdn.net/images/generic-something-missing-light-48bd739880.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/generic-something-wrong-dark-26e73c8e81.svg',
      light:
        'https://dt-cdn.net/images/generic-something-wrong-light-bde42196f6.svg',
    },
  },
  document: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/document-create-new-dark-94daf02a49.svg',
      light:
        'https://dt-cdn.net/images/document-create-new-light-144a3a8eda.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/document-no-permission-dark-5afe41d93a.svg',
      light:
        'https://dt-cdn.net/images/document-no-permission-light-6006132e25.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/document-no-result-dark-eb16d447ed.svg',
      light:
        'https://dt-cdn.net/images/document-no-result-light-743f227740.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/document-something-missing-dark-c87a4a01ba.svg',
      light:
        'https://dt-cdn.net/images/document-something-missing-light-b73c92d0d8.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/document-something-wrong-dark-796e70b2c6.svg',
      light:
        'https://dt-cdn.net/images/document-something-wrong-light-c8c5306fc5.svg',
    },
  },
};
